import { calculateTax } from './tax';

// Shipping cost calculation based on number of items
export const calculateShippingCost = (totalItems: number, zipCode: string, state: string, weight_grams: number): number => {
  let shipping_cost = 0;
  const box_weight_grams = calculateBoxWeight(totalItems);
  const total_weight_grams = weight_grams + box_weight_grams;

  if (total_weight_grams <= 600) {
    shipping_cost = 8;
  } else if (total_weight_grams <= 700) {
    shipping_cost = 9;
  } else if (total_weight_grams <= 900) {
    shipping_cost = 11;
  } else if (total_weight_grams <= 1300) {
    shipping_cost = 14;
  } else if (total_weight_grams <= 1800) {
    shipping_cost = 17;
  } else if (total_weight_grams <= 2300) {
    shipping_cost = 20;
  } else if (total_weight_grams <= 3100) {
    shipping_cost = 25;
  }
  
  return shipping_cost;
};

export const calculateBoxWeight = (totalItems: number): number => {
  // envelope 20 g
  // small box 100 g
  // medium box 200g 
  // large box 500g
  
  let box_weight_grams = 20;
  if (totalItems < 10) {
    box_weight_grams = 100;
  } else if (totalItems < 30) {
    box_weight_grams = 200;
  } else {
    box_weight_grams = 500;
  }
  return box_weight_grams;
};

// Total calculation including tax and shipping
export const calculateTotal = (subtotal: number, totalItems: number, zipCode: string, state: string, isPickup: boolean, weight_grams: number): {
  tax: number;
  shipping: number;
  total: number;
} => {
  let tax = 0;
  if (state === 'AR' || isPickup)
    tax = calculateTax(subtotal);
  // If subtotal is greater than or equal to $100, shipping is free
  const shipping = subtotal >= 100 ? 0 : calculateShippingCost(totalItems, zipCode, state, weight_grams);
  const total = Math.round((subtotal + tax + shipping) * 100) / 100;
  

  return {
    tax,
    shipping,
    total
  };
};
